import { useMutation, useQueryClient } from 'react-query';

import type { IStandardErrorResponse } from 'src/api/common';
import type { IShowing } from 'src/api/landlord-showings-api';
import { useNotifications } from 'src/notifications';
import { queryKeys } from 'src/services/api/constants';
import { apiClient } from 'src/services/api/client';

type IUpdateShowingResponse = {
    updated_tour: IShowing;
    has_sync_error: boolean;
};

export const useUpdateShowing = () => {
    const queryClient = useQueryClient();
    const { addNotification } = useNotifications();

    return useMutation<IUpdateShowingResponse, IStandardErrorResponse, IShowing>(
        async (showing) => {
            const res = await apiClient(`api/landlord/showings/${showing.id}`, {
                method: 'patch',
                json: { showing },
            }).json<IUpdateShowingResponse>();
            return res;
        },
        {
            onSuccess: (res) => {
                if (res.has_sync_error) {
                    addNotification(
                        'Tour updated, but its calendar event could not be synced',
                        'warning',
                    );
                } else {
                    addNotification('Tour updated successfully!', 'success');
                }
                queryClient.invalidateQueries(queryKeys.showings);
            },
            onError: (error) => {
                const errorMessage = error.msg || 'Failed to update tour';
                addNotification(errorMessage, 'error');
            },
        }
    );
};
